

angular
.module('inkfinder')
.factory('Notification', function Notification(
  $http,
  ENDPOINT,
  AlertMessages,
  RESPONSE_MESSAGES
) {
  // Public Methods
  Notification.send = send;

/**
  * @name sendNotification
  * @descriptions This function sends email notifications to users
  * @param {object} notification The notification to send
  * @return {object} Returns the Notification object
  */
  function send(notification) {
    return $http.post(ENDPOINT.server + 'emails/api/v1.1/notify/', notification)
    .then(function(response) {
      // Add if statement here to check the contents of the messages being sent
      if (response.data.includes('We couldn')) {
        AlertMessages.add({
          msg: response,
          type: 'warning'
        });
      } else {
        AlertMessages.add({
          msg: response,
          type: 'success'
        });
      }
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'});
      throw (error);
    });
  }
  return Notification;
});



// WEBPACK FOOTER //
// ./components/notifications/notifications.service.js